import { Component, inject } from '@angular/core';
import {LocaleService} from "../../../locale/locale.service";
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-language-selection',
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './language-selection.component.html',
  styleUrl: './language-selection.component.css'
})
export class LanguageSelectionComponent {
  localeService = inject(LocaleService);
}
